import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock($setup["PrimePanel"], {
    header: $props.header,
    pt: {...$setup.pt_default, ...$props.pt},
    collapsed: $data.collapsed,
    onClick: _cache[0] || (_cache[0] = $event => ($data.collapsed = !$data.collapsed))
  }, {
    header: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header", {}, undefined, true)
    ]),
    icons: _withCtx(() => [
      _createElementVNode("span", null, [
        _withDirectives(_createVNode(_component_Icon, {
          stroke: "var(--gray-400)",
          width: "2rem",
          heigth: "2rem",
          icon: "chevron-down"
        }, null, 512 /* NEED_PATCH */), [
          [_vShow, $data.collapsed]
        ]),
        _withDirectives(_createVNode(_component_Icon, {
          stroke: "var(--gray-400)",
          width: "2rem",
          heigth: "2rem",
          icon: "chevron-up"
        }, null, 512 /* NEED_PATCH */), [
          [_vShow, !$data.collapsed]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["header", "pt", "collapsed"]))
}